import React from 'react';
import { connect } from 'react-redux'
import {
  show_sidebar_report_actions,
  hide_sidebar_report_actions,
  get_project,
  create_optimized_report,
  reset_report_errors,
  upload_new
} from '../actions/'
import { Redirect } from 'react-router-dom'
import {
  is_logged_on,
  is_validating
 } from "../helpers"
 import {
  LocalForm,
  Control,
  actions
} from 'react-redux-form'
import ProjectOptimizations from './ProjectOptimizations';
import Loading from './Loading';
import Errors from './Errors'

const mapStateToProps = state => {
  return {
    report: state.report.report,
    mustRedirect: state.report.mustRedirect,
    fetching: state.report.fetching,
    fetched: state.report.fetched,
    creating_optimized: state.report.creating_optimized,
    errors: state.report.errors
  };
};

const mapDispatchToProps = dispatch => {
    return {
      getProject: (id, page, refreshing) => dispatch ( get_project(id, page, refreshing) ),
      createOptimized: (id, reportData) => dispatch( create_optimized_report(id, reportData) ),
      resetForm: () => dispatch( actions.reset('newReport') ),
      showActions: () => dispatch ( show_sidebar_report_actions() ),
      hideActions: () => dispatch ( hide_sidebar_report_actions() ),
      resetErrors: () => dispatch ( reset_report_errors() ),
      uploadNew: (id, formData) => dispatch ( upload_new(id, formData) ),
    }
}

class ConnectedProject extends React.Component {
  constructor () {
    super()
    this.state = {
      isHiddenNewReportForm: true,
      intervalTimer: false
    }
  }

  handleSubmit(values) {
    const { id } = this.props.match.params
    this.props.createOptimized(id, values)
  }

  componentDidUpdate(prevProps, prevState) {
    const creating_optimized = this.props.creating_optimized
    const prev_creating_optimized = prevProps.creating_optimized

    if ( creating_optimized !== prev_creating_optimized ) {
      if ( prev_creating_optimized ) {
        this.toggleHidden()
        this.props.resetForm()
      }
    }
  }

  componentDidMount() {
    const { id } = this.props.match.params
    this.props.showActions()
    this.props.getProject( id, 1, false )
  }

  componentWillUnmount() {
    this.props.hideActions()
    this.props.resetForm()
    this.props.resetErrors()
    if ( this.state.intervalTimer !== false ) {
      clearInterval(this.state.intervalTimer)
    }
  }

  toggleHidden () {
    this.setState({
      isHiddenNewReportForm: !this.state.isHiddenNewReportForm
    })
    this.props.resetErrors()
  }

  render() {
    const isHidden = this.state.isHiddenNewReportForm;
    const {fetching, fetched, errors, resetErrors, report, getProject} = this.props
    const {status, active, total_items} = report;

    if ( !is_validating() && !is_logged_on() ) {
      return <Redirect to="/" />
    }

    if (fetching || status === undefined) {
      return (
       <Loading />
      )
    }

    if ( !fetching && !fetched && errors !== undefined && errors !== null && errors.length > 0 ) {
      window.M.toast({
        html: errors
      })
      resetErrors()
      return <Redirect to="/" />
    }

    const pagination = (this.props.report.pagination === undefined || this.props.report.pagination === null) ? {} : this.props.report.pagination

    const optimizations = (typeof( this.props.report.optimizations ) === "undefined") ? [] : this.props.report.optimizations

    const optimizationsLength = optimizations.length;
    let hasOptimizations;

    let autoReload = false;

    if ( optimizationsLength > 0 ) {

      for(var i = 0; i < optimizationsLength; i++) {
        if ( optimizations[i].xml_pending === true || optimizations[i].entries === 0 || optimizations[i].xml_updating ) {
          autoReload = true
        }
      }

      hasOptimizations = <ProjectOptimizations optimizations={optimizations} pagination={pagination} report_id={this.props.match.params.id} />
    }

    if ( status &&  status.match(/^working/) ) {
      autoReload = true
      hasOptimizations = <ProjectOptimizations optimizations={optimizations} pagination={pagination} report_id={this.props.match.params.id} />

    }

    if ( autoReload ) {
      if ( this.state.intervalTimer === false) {
        const timer =  setInterval(function() {
          const report_id = report.id
          const { page } = pagination
          getProject( report_id, page, true )
        }, 5000)
        this.setState({intervalTimer: timer})
      }
    } else {
      if ( this.state.intervalTimer !== false ) {
        clearInterval(this.state.intervalTimer)
        this.setState({intervalTimer: false})
      }
    }

    let icon

    if ( active === false ) {
      icon = <i className="material-icons c-red">delete</i>;
    } else if ( status && status.match(/^idle/i)) {
      icon = <i className="material-icons c-light-green">sync</i>;
    } else if ( status &&  status.match(/^working/) ) {
      icon = <i className="material-icons orange-text">hourglass_empty</i>;
    }

    return (
      <div>
        <div className="collection with-header">
          <div className="collection-header red darken-1 white-text">
            <span className="flow-text">{report.name}</span>
          </div>

          <div className="collection-header">
            <div className="flex align-center justify-between">
              <div className="flex flex-left align-center">
                <h5 className="mr-10">Instances</h5>
                <button className={`btn red darken-1 waves-effect waves-light ${active ? '' : 'hide'}`}
                        onClick={this.toggleHidden.bind(this)} disabled={total_items === 0}>
                  Add New
                </button>
              </div>
              <div className="flex flex-right align-center relative">
                { icon }
                <button
                  className={`btn light-green waves-effect waves-light btn-small ${active ? '' : 'hide'}`}
                  disabled={status.match(/^working/)}
                  onClick={e=>{
                  e.preventDefault()
                  document.getElementById('uploadnewreport').click()
                }}>Upload New</button>
                <input type="file" id="uploadnewreport" style={{display:'none'}} onChange={e=>{
                  let formData = new FormData()
                  const { id } = this.props.match.params
                  const { page, per_page } = this.props.report.pagination
                  formData.append('file', e.target.files[0])
                  formData.append('per_page', per_page)
                  formData.append('page', page)
                  this.props.uploadNew(id, formData)
                }}/>

              </div>
            </div>

            <LocalForm
              model="newReport"
              className={isHidden ? 'hide' : ''}
              onSubmit = { (values) => {
                this.handleSubmit(values)
              }}
            >
              <div className="section">
                <div className="input-field">
                  <label htmlFor="thename">Add a name for the new report instance</label>
                  <Control.text id="thename" model= "newReport.name" />

                </div>
              </div>

              <Errors errors={this.props.errors} />
              <div className="section">
                <button type="submit" className="btn red darken-1 waves-effect waves-light">ADD NEW REPORT INSTANCE<i className="material-icons right">navigate_next</i></button>
              </div>
            </LocalForm>

            <p className="project_url"><span className="bold">Original File Name: </span>{report.file_name ? report.file_name : 'Uploaded from file'}</p>
          </div>

          {hasOptimizations}

        </div>
      </div>
    )
  }
}

const Project = connect(mapStateToProps, mapDispatchToProps)(ConnectedProject);

export default Project;



// WEBPACK FOOTER //
// ./src/js/components/Project.js